import moment from "moment";

export const makeVehicleDetail = (lead) => {
    let status = !!(lead.vehicle_registration || lead.make || lead.model);

    const leadState = {
        title: "Vehicle Details",
        info: [
            {
                name: "Registration",
                value: lead.vehicle_registration
                    ? lead.vehicle_registration
                    : "Not available",
            },
            {
                name: "Make",
                value: lead.make ? lead.make : "Not available",
            },
            {
                name: "Model",
                value: lead.model ? lead.model : "Not available",
            },
        ],
        status: { status },
    };

    if (lead.audatex_user) {
        leadState.info.push({
            name: "Vin",
            value: lead.vin ? lead.vin : "Not available",
        });
    }

    return leadState;
};

export const makeCustomerDetail = (lead) => {
    let status = true;
    const data = {
        title: "Customer Details",
        info: [
            {
                name: "Centre",
                value: lead.centre_name || "Not available",
            },
            {
                name: "Centre Reference",
                value: lead.centre_ref || "Not available",
            },
            {
                name: "Distrigo ID",
                value: lead.customer_trade_team_id || "Not available",
            },
            {
                name: "Contact Name",
                value: lead.customer_name || "Not available",
            },
            {
                name: "Contact Address",
                value: lead.customer_address || "Not available",
            },
            {
                name: "Contact Phone",
                value: lead.customer_phone || "Not available",
            },
            {
                name: "Contact Email",
                value: lead.customer_email || "Not available",
            },
        ],
        status: { status },
    };

    return data;
};

export const makeJobDetail = (lead) => {
    let status = true;
    let data = {
        title: "Job Details",
        info: [
            {
                name: "Job Reference",
                value: lead.job_ref || "Not available",
            },
            {
                name: "Confirmation Date",
                value: lead.confirmation_date
                    ? moment(lead.confirmation_date).format("DD/MM/YYYY HH:mm")
                    : "Not available",
            },
            {
                name: "Lead Creation",
                value: lead.created_at
                    ? moment(lead.created_at).format("DD/MM/YYYY HH:mm")
                    : "Not available",
            },
            {
                name: "Appointment Date",
                value: lead.appointment_at
                    ? moment(lead.appointment_at).format("DD/MM/YYYY HH:mm")
                    : "Not available",
            },
            {
                name: "Job Description",
                value: lead.job_description || "Not available",
            },
            {
                name: "Job Information",
                value: lead.job_information || "Not available",
            },
            {
                name: "Source",
                value: lead.source || "Not available",
            },
            {
                name: "Followed Up At",
                value: lead.followed_up_date
                    ? moment(lead.followed_up_date).format("DD/MM/YYYY HH:mm")
                    : "-",
            },
            {
                name: "Sale Status",
                value: lead.display_sale_status || "-",
            },
            {
                name: "Invoice",
                value: lead.invoice || "-",
            },
        ],
        status: { status },
    };

    //Merge in any extra Audatex data
    if (lead.audatex_user) {
        data = {
            ...data,
            info: [
                ...data.info,
                {
                    name: "Audatex Repair Cost Ex VAT £",
                    value: lead.repair_cost_exc_vat
                        ? lead.repair_cost_exc_vat
                        : "Not available",
                },
                {
                    name: "Assessment Ratio",
                    value: lead.assessment_ratio
                        ? lead.assessment_ratio
                        : "Not available",
                },
                {
                    name: "Authorisation Status",
                    value: lead.authorisation_status
                        ? lead.authorisation_status
                        : "Not available",
                },
                {
                    name: "Valuation £",
                    value: lead.valuation ? lead.valuation : "Not available",
                },
            ],
        };
    }

    return data;
};
